// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect, useState } from "react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";

import "./Dashboard.css";

// Root Component to demonstrate usage of wrapper component
function DashboardGpr() {
  // PowerBI Report object (to be received via callback)
  const [, setReport] = useState();

  // API end-point url to get embed config for a sample report

// OLD 2024
  // const sampleReportUrl ="https://app.powerbi.com/view?r=eyJrIjoiZDVkMjk4YWEtZTIyNC00ZDYzLWJmNTEtZTBjNTBlYjE0ZWYyIiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9";
    // "https://app.powerbi.com/view?r=eyJrIjoiODIwYzkxZjctNzQ2OC00MjAzLWFhMDUtYTRjNDA5NDQ2ZmY2IiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9";

  // new 2025
    const sampleReportUrl ="https://app.powerbi.com/view?r=eyJrIjoiZmM3ZGU2NWEtNmE5MS00NmJiLTgzNDYtYmExNjRjNTZmYmM2IiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9"





  // Report config useState hook
  // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below
  const [sampleReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: sampleReportUrl,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
  });


  
  // Map of event handlers to be applied to the embedding report
  const eventHandlersMap = new Map([
    [
      "loaded",
      function () {
        console.log("Report has loaded");
      }
    ],
    [
      "rendered",
      function () {
        console.log("Report has rendered");

        // Update display message
        setMessage("The report is rendered");
      }
    ],
    [
      "error",
      function (event) {
        if (event) {
          console.error(event.detail);
        }
      }
    ]
  ]);

  // Fetch sample report's config (eg. embedUrl and AccessToken) for embedding
  const mockSignIn = async () => {
    // Fetch sample report's embed config

    fetch(sampleReportUrl).then(async res => {
      const reportConfig = await res.json();
      setReportConfig({
        ...sampleReportConfig,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,        
          panes: {
            filters: {
              expanded: false,
              visible: false
            }
          }
        },        
        embedUrl: reportConfig.EmbedUrl,
        accessToken: reportConfig.EmbedToken.Token
      });
    })
      .catch(e => console.log(e))

  };

  const changeSettings = () => {
    // Update the state "sampleReportConfig" and re-render DemoApp component
    setReportConfig({
      ...sampleReportConfig,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,        
        panes: {
          filters: {
            expanded: false,
            visible: false
          }
        }
      }
    });
  };

  const [displayMessage, setMessage] = useState(
    `The report is bootstrapped. Click the Embed Report button to set the access token`
  );

  const controlButtons = (
    <div className="controls">
      <button onClick={mockSignIn}>Embed Report</button>

      <button onClick={changeSettings}>Hide filter pane</button>
    </div>
  );

  const header = (
    <div className="header">
      <div className="title">Power BI React component demo</div>
    </div>
  );

  useEffect(() => {
    // mockSignIn()
  }, [])

  return (
    <div>
      {/* {header} */}

      <PowerBIEmbed
        embedConfig={sampleReportConfig}
        eventHandlers={eventHandlersMap}
        cssClassName={"report-style-class"}
        getEmbeddedComponent={(embedObject) => {
          console.log(
            `Embedded object of type "${embedObject.embedtype}" received`
          );
          setReport(embedObject);
        }}
      />


    </div>
  );
}

export default DashboardGpr;
